import Service from "../../../Services/index";

const Shipping = {
    namespaced: true,
    state: {
        customer_shipping : [],
        shipping_fee: [],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
        selected : [],
        search : {
            customer : null,
            area :null,
            province :null,
            district : null,
            sale : null,
        },
    },
    mutations: {
        SET_CUSTOMER_SHIPPING :(state,res)=>{
            state.customer_shipping = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        SET_SHIPPING_FEE: (state, res) => {
            state.shipping_fee = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        SET_SELECT_ALL:(state,res)=>{
            state.selected = res;
        },
        CLEAR_SEARCH : (state)=>{
            state.selected = [];
            state.search = {
                customer : null,
                area :null,
                province :null,
                district : null,
                sale : null,
            }
        }
    },
    actions: {
        getCustomerShipping({commit},{page=1,data}){
            return Service.Shipping.searchCustomerShipping(page,data).then(res=>{
                commit("SET_CUSTOMER_SHIPPING",res);
            })
        },
        setShipping({ commit },page=1) {
            return Service.Shipping.getShipping(page)
                .then(data => {
                commit("SET_SHIPPING_FEE", data);
            });
        },
        create({commit},data){
            return Service.Shipping.createShipping(data)
                .then(res=>{
                console.log(res);
            })
        },
        search({commit},{page=1,date}){
            return Service.Shipping.searchEditShipping(page,date)
                .then(res=>{
                    commit("SET_SHIPPING_FEE", res);
                })
        },
        selectAllAPI({commit},search) {
            return Service.Shipping.selectAll(search)
                .then(res=>{
                    commit("SET_SELECT_ALL",res);
                })
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        }
    }
};

export default Shipping;
